// extracted by mini-css-extract-plugin
module.exports = {"light":"LanguageSelector_light__lFo8m","dark":"LanguageSelector_dark__l80aJ"};